<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      @select="menuSelect">
      <template v-for="item in items">
        <template v-if="item.enable">
          <template v-if="item.subs">
            <el-submenu :index="item.index" :key="item.index">
              <template slot="title">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.title }}</span>
              </template>
              <template v-for="subItem in item.subs">
                <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                  <template slot="title">{{ subItem.title }}</template>
                  <el-menu-item
                    v-for="(threeItem,i) in subItem.subs"
                    :key="i"
                    :index="threeItem.index"
                  >{{ threeItem.title }}
                  </el-menu-item>
                </el-submenu>
                <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}</el-menu-item>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :index="item.index" :key="item.index">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </template>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import bus from "./bus";

  export default {
    computed: {
      ...mapState(["LoginInfo"]),
      onRoutes() {
        // console.log(this.$route.path)
        return this.$route.path.replace("/", "");
      }
    },
    watch: {
      "LoginInfo.account" (val, oldVal) {
        if (val !== oldVal) {
          if (!this.isCheckPemission) {
            this.checkPemission()
          }
        }
      }
    },
    data() {
      return {
        collapse: false,
        items: [
          {
            icon: "el-icon-s-home",
            index: "home",
            title: "首页"
          },
          {
            icon: "el-icon-document",
            index: "nurse",
            title: "护士站列表",
            admin: 1
          },
          {
            icon: "el-icon-document-checked",
            index: "baby",
            title: "宝宝列表"
          }
        ]
      };
    },
    created() {
      if (this.LoginInfo.account) {
        this.checkPemission()
      }
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on("collapse", msg => {
        this.collapse = msg;
        bus.$emit("collapse-content", msg);
      });
    },
    methods: {
      menuSelect(item) {
        console.log(item);
        this.$router.push({
          path: "/" + item
        });
      },
      checkPemission () {
      // console.log(this.items)
        const account = this.LoginInfo.account
        if (!account) return false
        for (let item of this.items) {
        	// console.log(item)
          if (item.admin) {
            if (account.admin) {
              this.$set(item, 'enable', true)
            }
          } else {
            this.$set(item, 'enable', true)
          }
        }
        this.isCheckPemission = true
      }
    }
  };
</script>

<style scoped>
  .sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
    z-index: 10;
  }

  .sidebar::-webkit-scrollbar {
    width: 0;
  }

  .sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;
  }

  .sidebar > ul {
    height: 100%;
  }

  .el-menu-item.is-active {
    background-color: #283446 !important;
  }
</style>



// WEBPACK FOOTER //
// src/common/Sidebar.vue